import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Col, UiImage, UiQuestionnaireLayout, UiText} from '~/components/elements';
import {ScrollToBottomButton} from '~/components/shared/ScrollToBottomButton';
import {ACNE_TELECONSULTATION_KEYS} from '~/constants/medical-questionnaires';
import {useInput} from '~/hooks';
import {setNextQuestionnaire, setQuestionnaireAnswer} from '~/redux/questionnaires/slice';
import {RootState} from '~/redux/root-reducer';
import {AppDispatch} from '~/redux/root-store';
import {spacing} from '~/utils/theme/spacing';

const Questionnaire5Screen = () => {
  const dispatch: AppDispatch = useDispatch();
  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);

  const questionnaires = medicalQuestionnaire?.questionnaires;
  const questionnaire = questionnaires?.find(i => i.key === ACNE_TELECONSULTATION_KEYS.SKIN_TYPE);
  const currentAnswer = useSelector(
    (state: RootState) => state.questionnaires?.collectData[ACNE_TELECONSULTATION_KEYS.SKIN_TYPE]?.data,
  );
  const {inputs, setInputs} = useInput({selectedOption: currentAnswer?.selectedOption || ''});

  const onClickSubmit = () => {
    dispatch(
      setQuestionnaireAnswer({
        key: ACNE_TELECONSULTATION_KEYS.SKIN_TYPE,
        index: questionnaire?.index || '',
        data: inputs,
      }),
    );
    dispatch(setNextQuestionnaire({value: ACNE_TELECONSULTATION_KEYS.DESCRIBE_SKIN_CONDITION}));
  };

  const onClickOption = (value: string) => {
    setInputs({selectedOption: value});
  };

  return (
    <UiQuestionnaireLayout
      handleOnNext={onClickSubmit}
      checkoutStep={questionnaire?.checkoutStep}
      actions={questionnaire?.actions}
      disableNext={!inputs.selectedOption}
    >
      <Col alignItems="center" textAlign="center">
        <UiImage type="icon" name={questionnaire?.icon} boxSize={spacing.mLarge} mt={spacing.small} />
        <UiText fontSize="xl" fontWeight="bold" my={spacing.medium}>
          {questionnaire?.questions?.default}
        </UiText>
        {questionnaire?.options?.map(value => (
          <ScrollToBottomButton
            key={`${value.label}-${value.value}`}
            title={value.label}
            variant={inputs.selectedOption === value.value ? 'solid' : 'toggle'}
            onClick={() => onClickOption(value.value as string)}
            height="35px"
            w="100%"
            mb={5}
          />
        ))}
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default Questionnaire5Screen;
